const SINGLE_SALUTATIONS = [
  "mr",
  "mrs",
  "ms",
  "miss",
  "mdm",
  "madam",
  "dr",
  "prof",
  "professor",
  "sir",
  "dame",
  "dato",
  "datuk",
] as const;

const COMPOUND_SALUTATIONS = ["tan sri"] as const;

const SINGLE_SALUTATION_RE = new RegExp(
  `^(${SINGLE_SALUTATIONS.join("|")})(?:\\.|\\s|,)+`,
  "i",
);

const SINGLE_SALUTATION_STUCK_RE = new RegExp(
  `^(${SINGLE_SALUTATIONS.join("|")})\\.(?=[A-Za-z])`,
  "i",
);

const COMPOUND_SALUTATION_RE = new RegExp(
  `^(${COMPOUND_SALUTATIONS.join("|")})(?:\\.|\\s|,)+`,
  "i",
);

/** Strip leading honorifics only. Leaves the remainder intact. */
export function stripLeadingCustomerSalutation(raw: string): string {
  let value = raw.trim();
  if (!value) return "";

  let previous = "";
  while (value && value !== previous) {
    previous = value;
    const compound = value.match(COMPOUND_SALUTATION_RE);
    if (compound) {
      value = value.slice(compound[0].length).trim();
      continue;
    }
    const stuck = value.match(SINGLE_SALUTATION_STUCK_RE);
    if (stuck) {
      value = value.slice(stuck[0].length).trim();
      continue;
    }
    const single = value.match(SINGLE_SALUTATION_RE);
    if (single) {
      value = value.slice(single[0].length).trim();
    }
  }
  return value;
}

export function applyCustomerDisplayCasing(raw: string): string {
  const compact = raw.trim().replace(/\s+/g, " ");
  if (!compact) return "";
  return compact
    .split(" ")
    .map((part) => {
      const lower = part.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
}

/** Display-name authority: salutations off, then compact + title-case. */
export function normaliseCustomerDisplayName(raw: string): string {
  return applyCustomerDisplayCasing(stripLeadingCustomerSalutation(raw));
}
